export const DASHBOARD_CONFIG_KEY = "sgbv-dashboard-config";

export const DEFAULT_DASHBOARD_CONFIG = Object.freeze({
  dashboardTitle: "SGBV Intelligence Dashboard",
  dashboardSubtitle: "Survivor-centred reporting and response intelligence",
  footerOrganization: "Monitoring & Evaluation Technical Support (METS)",
  showDemographics: true,
  showAiInsights: true,
  showServiceTables: true,
});

export const loadDashboardConfig = () => {
  try {
    const storedConfig = window.localStorage.getItem(DASHBOARD_CONFIG_KEY);
    return storedConfig
      ? { ...DEFAULT_DASHBOARD_CONFIG, ...JSON.parse(storedConfig) }
      : { ...DEFAULT_DASHBOARD_CONFIG };
  } catch (error) {
    return { ...DEFAULT_DASHBOARD_CONFIG };
  }
};

export const saveDashboardConfig = config => {
  const normalizedConfig = { ...DEFAULT_DASHBOARD_CONFIG, ...config };
  window.localStorage.setItem(
    DASHBOARD_CONFIG_KEY,
    JSON.stringify(normalizedConfig)
  );
  return normalizedConfig;
};

export const resetDashboardConfig = () => {
  window.localStorage.removeItem(DASHBOARD_CONFIG_KEY);
  return { ...DEFAULT_DASHBOARD_CONFIG };
};
